import classNames from "classnames";
import styles from "./style.module.scss";

interface LoaderProps {
  text?: string;
  className?: string;
}

export default function Loader({ text, className }: LoaderProps) {
  const loaderClasses = classNames(styles.loader, className);

  return (
    <div className={loaderClasses}>
      <div className={styles.spinner}></div>
      {text && <div className={styles.text}>{text}</div>}
    </div>
  );
}
